const color = function() {
};

color.prototype = {
    /**
     * Convert to numerical value
     *
     * @param {string} value
     * @returns {number}
     */
    hashCode(value) {
        let hash = 0;
        for (let i = 0; i < value.length; i++) {
            hash = value.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    },

    /**
     * Convert to HEX color value (e.g. #000FFF)
     *
     * @param {number} i
     * @returns {string}
     */
    intToRGB(i) {
        let c = (i & 0x00FFFFFF)
            .toString(16)
            .toUpperCase();

        return '#' + '00000'.substring(0, 6 - c.length) + c;
    },

    /**
     * Generates a nice color that is user readable on the view interface, for the base color that is provided
     *
     * @param {string} baseColor
     * @returns {string}
     */
    niceColor(baseColor) {
        let hsl = this.convertRgbToHsl(baseColor);
        hsl[0] = (hsl[0]+0.5) % 1; // Hue
        hsl[1] = (hsl[1]+0.5) % 1; // Saturation
        hsl[2] = (hsl[2]+0.5) % 1; // Luminocity
        return 'hsl('+(hsl[0]*360)+','+(hsl[1]*100)+'%,'+(hsl[2]*100)+'%)';
    },

    /**
     * Convert RGB to HSL
     *
     * @param {string} clr
     * @returns {[number, number, number]}
     */
    convertRgbToHsl(clr) {
        let rgb = clr.substring(4, clr.length-1).replace(/ /g, '').split(',');
        return this.rgbToHsl(rgb[0],rgb[1],rgb[2]);
    },

    /**
     * Adjust the RGB values to HSL values
     *
     * @param {string} r
     * @param {string} g
     * @param {string} b
     * @returns {(number)[]}
     */
    rgbToHsl(r, g, b) {
        r /= 255;
        g /= 255;
        b /= 255;

        var max = Math.max(r, g, b), min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if (max === min) {
            h = s = 0; // achromatic
        } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

            switch (max) {
                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                case g: h = (b - r) / d + 2; break;
                case b: h = (r - g) / d + 4; break;
            }

            h /= 6;
        }

        return [ h, s, l ];
    },

    /**
     * Convert HEX to RGB value
     *
     * @param {string} value
     * @returns {string}
     */
    convertHexToRgb(value) {
        var aRgbHex = value.replace('#', '').match(/.{1,2}/g);
        var aRgb = [
            parseInt(aRgbHex[0], 16),
            parseInt(aRgbHex[1], 16),
            parseInt(aRgbHex[2], 16)
        ];

        return 'rgb(' + aRgb.join(',') + ')';
    },

    convertHexToRgba(hex, opacity) {
        // Remove the leading hash if present
        hex = hex.replace(/^#/, '');

        // Parse the r, g, b values from the hex string
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);

        // Return the RGBA string
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
};

export const colorHelper = new color();
